export default __webpack_public_path__ + "static/media/customers.cfc621e8.svg";